import * as S from '../styles'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import moment from 'moment'

export type SignatureAlreadySignedProps = {
  signedAt: Date | undefined
}

const SignatureAlreadySigned = ({ signedAt }: SignatureAlreadySignedProps) => {
  const newDate = moment(signedAt).format('DD/MM/YYYY HH:mm:ss')
  return (
    <S.IconWrapper>
      <CheckCircleOutlineIcon
        style={{ color: '#95C567', fontSize: 96, marginBottom: 10 }}
      />
      <S.IconText>Este Contrato foi assinado em: {newDate}</S.IconText>
    </S.IconWrapper>
  )
}
export default SignatureAlreadySigned
